module.exports = __webpack_public_path__ + "static/media/glo.18a57718.svg";